import React, { useEffect } from "react";
import AboutSection from "../components/AboutUS/AboutSection";
import AboutCounter from "../components/AboutUS/AboutCounter";
import AboutTeam from "../components/AboutUS/AboutTeam";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getAboutData } from "../features/about";
import { Banner } from "../components/common/Banner";
import { Loader } from "../components/common/Loader";
import { getMultiLanguageData } from "../features/multiLanguage";

const AboutUs: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { details, statistics, teamMembers, aboutUsLoader, status } = useAppSelector(state => state.about);
    const { menu } = useAppSelector(state => state.menuAccess);

    const { abutus_sections } = menu?.about_us || {};

    useEffect(() => {
        dispatch(getAboutData());
        // dispatch(getMultiLanguageData())
    }, [dispatch, status]);

    if (aboutUsLoader) {
        return <Loader />
    }

    return (
        <>

            <Banner banner_title={banner_title} />

            {
                abutus_sections && abutus_sections?.about_section &&

                <AboutSection details={details} />
            }
            {
                abutus_sections && abutus_sections?.about_counter &&

                <AboutCounter statistics={statistics} />
            }
            {
                abutus_sections && abutus_sections?.about_team &&

                <AboutTeam teamMembers={teamMembers} />
            }


        </>

    )
}
export default AboutUs;